import styled, { css } from 'styled-components';

// z-index is 2 more than Add to Calendar, MessageBubble only 1
const Nav = styled.nav`
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  z-index: ${99998 + 2};
  background-color: ${(props) => props.theme.mainBackgroundColor};
  position: absolute;
  top: 0;
  left: -100vw;
  right: 0;
  overflow: scroll;
  transition: all .4s ease;
  ${(props) => props.menuIsOpen && css`
    left: 0;
    @media all and (min-width: ${props.theme.breakingpoints.xl}) {
      left: auto;
    }
  `}
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    height: auto;
    width: auto;
    z-index: 1;
    background-color: transparent;
    position: static;
    top: auto;
    left: auto;
    right: auto;
    overflow: visible;
    transition: all 0s ease;
    padding-left: 20px;
  }
`;

export default Nav;
